import React from "react";
import "../css/testimonial.css";
import UserListView from "../components/UserListView";
import ReactPaginate from 'react-paginate';
//import '@fortawesome/fontawesome-free/css/all.min.css';
import { fetchUserStudent } from "../../../config/fetchUserFull";
import Loading from "../components/Loading";

class StudentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            loading: false,
            currentPage: 1,
            postsPerPage: 10,
            isLoading: false,
            searchTerm: "",
            startDate: "",
            endDate: ""
        };
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });

            const data = await fetchUserStudent();

            if (data && data.length > 0) {
                this.setState({
                    posts: data, loading: false
                });
            } else {
                console.log('No data found');
            }

        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handlePageChange = ({ selected }) => {
        this.setState({ currentPage: selected + 1 });
    };

    handleSearchChange = (event) => {
        this.setState({ searchTerm: event.target.value });
    };

    handleStartDateChange = (event) => {
        this.setState({ startDate: event.target.value });
    };

    handleEndDateChange = (event) => {
        this.setState({ endDate: event.target.value });
    };

    clearFilters = () => {
        this.setState({
            searchTerm: "",
            startDate: "",
            endDate: ""
        });
    };

    render() {
        const { posts, loading, currentPage, postsPerPage, searchTerm, startDate, endDate, isLoading } = this.state;
        const indexOfLastPost = currentPage * postsPerPage;
        const indexOfFirstPost = indexOfLastPost - postsPerPage;

        const filteredPosts = posts.filter(post => {
            const postDate = new Date(post.join_date); // Assuming post.date is the date field
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;
            
            const matchesSearchTerm = post.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                      post.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                      post.email_address.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                      post.mobile.includes(searchTerm);
            
            const withinDateRange = (!startDate || (postDate >= start)) && (!endDate || (postDate <= end));

            return matchesSearchTerm && withinDateRange;
        });

        const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                {isLoading ? (
                    <Loading size={100} />
                ) : posts.length > 0 ? (
                    <div className="header">
                        <h2>Student List</h2>
                        <div className="search-bar-container">
                        <input 
                            type="text"
                            placeholder="Search by name, role, email, or mobile"
                            value={searchTerm}
                            onChange={this.handleSearchChange}
                            className="search-bar"
                        />
                        <input 
                            type="date"
                            value={startDate}
                            onChange={this.handleStartDateChange}
                            className="date-input"
                        />
                        <input 
                            type="date"
                            value={endDate}
                            onChange={this.handleEndDateChange}
                            className="date-input"
                        />
                        <button onClick={this.clearFilters} className="clear-button">Clear</button>
                        </div>
                        <UserListView posts={currentPosts} loading={loading} />
                        <ReactPaginate
                            onPageChange={this.handlePageChange}
                            pageCount={Math.ceil(filteredPosts.length / postsPerPage)}
                            previousLabel={'Prev'}
                            nextLabel={'Next'}
                            containerClassName={'pagination'}
                            pageLinkClassName={'page-number'}
                            previousLinkClassName={'page-number'}
                            nextLinkClassName={'page-number'}
                            activeLinkClassName={'active'}
                        />
                    </div>
                ) : (
                    <p>No data available</p>
                )}
            </div>
        );
    }
}

export default StudentList;
